import React, { useState } from "react";
import CommentType from "../../js/models/CommentType";
import { useContext } from "react";
import CredentialsContext from "../contexts/CredentialsContext";

import "../css/comment-list.css";

/*
  Элемент списка комментариев
*/
export default function CommentShortInfo(props) {
  const comment = props.comment;
  let placeType = CommentType[comment.comment_type].subform.variants[comment.element].fullName;
  const {credentials} = useContext(CredentialsContext);
  let gameName = comment.game_id !== undefined ? credentials.games[comment.game_id]?.name : "не указана";


  return (
    <React.Fragment>
      <h3 className="comment-type">
         Тип комментария: {CommentType[comment.comment_type].fullName} ({comment.id})
      </h3>
      <div>Игра: {gameName}</div>
      <div>Тип элемента: {placeType}</div>
      <div className="comment-username-datetime">
        <span className="comment-username">Автор: {comment.username}</span>
        <span> : </span>
        <span className="comment-datetime">Время: {comment.datetime}</span>
      </div>
    </React.Fragment>
  )
}
